export default{
    init(){
        this.updateSubscriptionSettings();
    },

    updateSubscriptionSettings(){
        let $this= this;
        $('.email-notifications').on('change', '#service_updates, #news, #promotional_emails, #completion_notification, #visit_notifications, #reminder', function() {
            /* if($('#user_t').val() == ''){
                return;
            } */
            let named = $(this).attr('id')
            let data = new Map([
                ['token', $('#user_t').val()],
                [named, $(this).is(':checked') ? 1 : 0],
            ]);
            data = Object.fromEntries(data);
            $this.sendUnsubscribeData(data);
        });
        $('#save-subscription-settings').click(function() {
            location.reload(true);
        });

    },

    sendUnsubscribeData(data){
        $.ajax({
            type: 'POST',
            url: '/email-department/update-subscriptions',
            data: data,
            success: function (response) {
                console.log(response);
            },
            error: function (response) {
                console.log(response);
            }
        });
    }
}
